module.exports = __webpack_public_path__ + "img/Johnston_Twisp_4204.7a48cb1b.jpg";